import { render } from "./HeroiconsSolidSparkles.vue?vue&type=template&id=ebd47004"
const script = {}

import exportComponent from "/Users/mq/Projects/siinadmin/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidSparkles.vue"]])

export default __exports__